import { app } from '../../../../../bootstrap/core';
import { uploadWarrantState, uploadWarrantStateName } from './uploadWarrant.state';
import { uploadWarrantComponent } from './uploadWarrant.component';

app.config(uploadWarrantState);
app.component(uploadWarrantComponent.name, uploadWarrantComponent);
app.constant('uploadWarrantStateName', uploadWarrantStateName);